/**
 * Данные пишутся раз в тридцать секунд, чаще опрашивать нечего.
 */
export const REFRESH_INTERVAL = 30_000;

export const DEFAULT_SERVICE = "gateway.microservice";

export const RANGE_OPTIONS = [
	{ key: "hour", minutes: 60 },
	{ key: "threeHours", minutes: 180 },
	{ key: "twelveHours", minutes: 720 },
	{ key: "day", minutes: 1440 },
	{ key: "threeDays", minutes: 3 * 24 * 60 },
] as const;

export type RangeKey = (typeof RANGE_OPTIONS)[number]["key"];

/**
 * Цвета линий графика: по одной на экземпляр сервиса.
 */
export const POD_COLORS = [
	"#03A9F4",
	"#E63740",
	"#4CAF50",
	"#FF9800",
	"#9C27B0",
	"#009688",
];
